import { render, staticRenderFns } from "./TheSalonSection.vue?vue&type=template&id=4bd038ea"
import script from "./TheSalonSection.vue?vue&type=script&lang=js"
export * from "./TheSalonSection.vue?vue&type=script&lang=js"
import style0 from "./TheSalonSection.vue?vue&type=style&index=0&id=4bd038ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports